import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=558bba4a&scoped=true"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=558bba4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558bba4a",
  null
  
)

export default component.exports